import { render } from "./TimeSelect.vue?vue&type=template&id=b676bb18"
import script from "./TimeSelect.vue?vue&type=script&lang=ts"
export * from "./TimeSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script